module.exports = __webpack_public_path__ + "static/media/Union.ac963840.svg";